<template>
  <div
    class="sidebar-bg"
    :style="{ '--sidebar-accent': themeColor }"
  >
    <!-- <div class="sidebar-title">
      <img :src="logoImage" style="width: 32px; height: 32px; border-radius: 50%" />
      <p class="sidebar-title-text">{{ getProjectName() }}</p>
    </div> -->
    <div class="left-menu" style="height: 100%">
      <el-scrollbar wrap-class="scrollbar_dropdown__wrap" style="height: 100%">
        <!-- <el-menu
          ref="menu"
          mode="vertical"
          :default-active="getCurrentMenuId"
          :unique-opened="true"
          @select="selectMenu"
          :active-text-color="activeTextColor"
          :collapse="getCollapse"
        >
          <template v-for="menu in getMenuList">
            <menu-item :menu="menu" :key="menu.menuId" />
          </template>
        </el-menu> -->
        <el-menu
          :default-openeds="openeds"
          :default-active="defaultActive"
          :collapse="getCollapse"
          background-color="#fff"
          text-color="#555555"
          :active-text-color="themeColor"
          :collapse-transition="false"
          @select="selectMenu"
          ref="menu"
          mode="vertical"
        >
          <template v-for="menu in sidebarList">
            <menu-item :menu="menu" :key="menu.menuId" />
          </template>
        </el-menu>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import menuItem from "./menu-item.vue";
import { mapGetters, mapMutations } from "vuex";
import projectConfig from "@/core/config";

export default {
  data() {
    return {
      sidebarList: [],
      openeds: [],
      isCollapse: false,
      collapseLeft: "200px",
      showCollapseBtn: true,
      logoImage: require("../../../../assets/img/logo.png"),
      defaultActive: null,
    };
  },
  components: {
    "menu-item": menuItem,
  },
  computed: {
    themeColor() {
      return this.$root.color || "#1476c3";
    },
    activeTextColor() {
      return undefined;
    },
    getCollapseStyle() {
      return [
        {
          left: this.collapseLeft,
        },
      ];
    },
    ...mapGetters([
      "getMultiTags",
      "getMenuList",
      "getCollapse",
      "getCurrentMenuPath",
      "getCurrentMenuId",
      "getMultiColumn",
    ]),
  },
  watch: {
    "$root.menuId": {
      handler() {
        this.setList();
      },
    },
    "$root.route_path": {
      handler() {
        this.getList();
      },
    },
  },
  created() {
    this.getList();
    // this.$nextTick(()=>{
    //   var data = this.getMenuList
    //   var datas = data.filter(a=>a.menuName=="客户管理")
    // })
  },
  methods: {
    getList() {
      this.defaultActive = this.$root.menuId;
      this.sidebarList = this.$root.route_path;
      this.openeds = [this.$root.route_path[0].menuId];
      if (this.$root.route_path[0].children) {
        this.openeds.push(this.$root.route_path[0].children[0].menuId);
      }
    },
    setList() {
      this.defaultActive = this.$root.menuId;
      this.sidebarList = this.$root.route_path;
    },
    onCollapseChange() {
      this.showCollapseBtn = false;
      setTimeout(() => {
        this.setCollapse(!this.getCollapse);
        this.collapseLeft = this.getCollapse ? "65px" : "200px";
        this.showCollapseBtn = true;
      }, 100);
    },
    getProjectName() {
      if (this.getCollapse) {
        return projectConfig.projectName.substr(0, 1);
      } else {
        return projectConfig.projectName;
      }
    },
    selectMenu(index, path) {
      this.$root.menuId = index;
      this.removeTag(index);
      setTimeout(() => {
        this.setCurrentMenuId(index);
      }, 5);
      if (!this.getMultiTags) {
        this.clearAllTags();
      }
      // this.$root.menuId = index;
      // if (this.getCurrentMenuId === index) return;
      // if (!this.getMultiTags) {
      //   this.clearAllTags();
      // }
      // this.setCurrentMenuId(index);
    },
    ...mapMutations([
      "removeTag",
      "setCollapse",
      "clearAllTags",
      "setCurrentMenuId",
      "closeOtherTags",
    ]),
  },
};
</script>

<style scoped>
.sidebar-bg {
  height: 100%;
  position: relative;
  border-right: 1px solid #dddbdb;
  --sidebar-accent: #1476c3;
  --sidebar-accent-bg: #e8f1f9;
}

.sidebar-title-text {
  font-size: 18px;
  font-weight: bold;
}

/* 覆盖主题里残留的深色侧栏 / 旧绿色，与主体主色 #1476c3 对齐 */
::v-deep .el-menu {
  background-color: #fff !important;
}

::v-deep .el-menu-item,
::v-deep .el-submenu__title {
  background-color: #fff !important;
  color: #555555;
}

::v-deep .el-menu-item:hover,
::v-deep .el-menu-item:focus,
::v-deep .el-submenu__title:hover,
::v-deep .el-submenu__title:focus {
  background-color: var(--sidebar-accent-bg) !important;
}

::v-deep .el-menu-item.is-active {
  background-color: var(--sidebar-accent-bg) !important;
  color: var(--sidebar-accent) !important;
  border-right: 3px solid var(--sidebar-accent);
}

::v-deep .el-menu-item.is-active i,
::v-deep .el-submenu.is-active > .el-submenu__title,
::v-deep .el-submenu.is-active > .el-submenu__title i {
  color: var(--sidebar-accent) !important;
}
</style>
